import {
  Heading,
  Text,
  type HeadingAlign,
  type HeadingLevel,
  type TextProps,
} from 'platform/foundation';
import {useFormatCurrency} from 'platform/locale';

export type MoneyTextProps = {
  amount: string;
  currency: string;
  size?: TextProps['size'];
  /** Render as a heading of the given level instead of body text. */
  headingSize?: HeadingLevel;
  alternative?: boolean;
  color?: TextProps['color'];
  align?: HeadingAlign;
  noWrap?: boolean;
};

export function MoneyText(props: MoneyTextProps) {
  const formatCurrency = useFormatCurrency();
  // Money remains a decimal string in state; this conversion is display-only and is never used for arithmetic.
  const amount = Number(props.amount);
  const formatted = Number.isFinite(amount) ? formatCurrency(amount, props.currency, 2) : '—';

  if (props.headingSize) {
    return (
      <Heading
        size={props.headingSize}
        color={props.color ?? undefined}
        align={props.align}
        isSingleLine={props.noWrap}
      >
        {formatted}
      </Heading>
    );
  }

  return (
    <Text
      size={props.size}
      alternative={props.alternative}
      color={props.color}
      align={props.align}
      noWrap={props.noWrap}
    >
      {formatted}
    </Text>
  );
}
